export default __webpack_public_path__ + "static/media/byo-drink.8b9d5ba1.svg";